import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@material-ui/core/Button";
import { FastField, Field, Form, Formik, useFormikContext } from "formik";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useMediaQuery } from "@material-ui/core";
import { themeButtons } from "../../css/themeButtons";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import ModalChangeCalendar from "../common/Modals/ModalChangeCalendar";
import DateRangePickerComponent from "../common/DateRangePickerComponent/DateRangePickerComponent";
import AutoSaveWithDebounce from "../common/Autosave/AutoSaveWithDebounce";
import Month from "../common/CalendarPieces/Month";
import { usePrevious } from "../common/CustomHook/usePrevious";
import { CustomInputNumber } from "./styles";
import Preloader from "../common/Preloader/Preloader";
import { NavLink, useHistory } from "react-router-dom";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Modal from "../common/Modals/Modal";


const RenderSettingsMenu = ({
  roomsList,
  objectsAvailability,
  objectId,
  roomId,
  changeRoom,
  changeObject,
  headerSubtitle
}) => {
  const mobileAgent = useMediaQuery('(max-width: 974px)');

  const [showInstruction, setShowInstruction] = useState(false);
  const toggleShowInstruction = () => {
    setShowInstruction(!showInstruction)
  }

  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const history = useHistory()
  const onSubmit = (values) => {
    if (values.room !== roomId) {
      changeRoom(values.room)
    }
    if (values.object !== objectId) {
      history.push(values.object)
      changeObject(values.object)
      changeRoom(null)
    }
    setExpanded(false);
  }
  const buttons = themeButtons()
  return (
    <div id="settings-menu">
      <Formik initialValues={{ room: roomId, object: objectId }}
              enableReinitialize
              onSubmit={onSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <div className="container-fluid">

              <div className="d-flex">
                <Button className="d-lg-none px-3 py-2"
                        startIcon={<FontAwesomeIcon icon={"ellipsis-v"}/>}
                        type="button"
                        onClick={handleExpandClick}>
                  Выбрать номер
                </Button>
                <div className="select-room-month d-none d-lg-block">
                  <div className="row gx-1 gy-2 align-items-center">
                    <div className="col-auto mt-0">
                      <h5 className="m-0 me-2">Количество свободных номеров</h5>
                    </div>
                    <div className="col-auto">
                      <div className="row g-1">
                        <div className="col" key={Math.random()}>
                          <Field name="room">
                            {({ field }) => (
                              <FormControl variant="outlined" size="small" fullWidth
                                           disabled={roomsList.length === 0}
                                           style={{ minWidth: '185px' }}>
                                <InputLabel>Выберите номер</InputLabel>
                                <Select
                                  label="Выберите номер"
                                  {...field}
                                >
                                  {roomsList.map(room => {
                                    return <MenuItem key={room.id}
                                                     value={String(room.id)}>
                                      {room.name}
                                    </MenuItem>
                                  })}


                                </Select>
                              </FormControl>
                            )}
                          </Field>
                        </div>
                        {!headerSubtitle &&
                          <div className="col">
                            <Field name="object">
                              {({ field }) => (
                                <FormControl variant="outlined" size="small" fullWidth
                                             className="long-select"
                                             style={{ minWidth: "148px" }}>
                                  <InputLabel>Выберите объект</InputLabel>
                                  <Select
                                    label="Выберите объект"
                                    {...field}
                                  >
                                    {objectsAvailability && objectsAvailability.map(obj => {
                                      return <MenuItem key={obj.id}
                                                       value={String(obj.id)}>
                                        {obj.name}
                                      </MenuItem>
                                    })}

                                  </Select>
                                </FormControl>
                              )}
                            </Field>
                          </div>
                        }
                      </div>


                    </div>

                  </div>
                </div>
                <Box className="instruction" onClick={toggleShowInstruction}>
                  <span className="instruction__text">Инструкция</span>
                  <IconButton>
                    <FontAwesomeIcon icon={["far", "question-circle"]}/>
                  </IconButton>
                </Box>
              </div>


            </div>
            <Collapse in={mobileAgent && expanded} timeout="auto" unmountOnExit>
              <div className="container-fluid select-room-month-mobile">
                <div className="row g-3 pb-3">
                  <div className="col-12">
                    <FastField name="room">
                      {({ field }) => (
                        <FormControl variant="outlined" size="small" fullWidth
                                     className="long-select">
                          <InputLabel>Выберите номер</InputLabel>
                          <Select
                            label="Выберите номер"
                            {...field}
                          >
                            {roomsList && roomsList.map(room => {
                              return <MenuItem key={room.id} value={room.id}>
                                {room.name}
                              </MenuItem>
                            })}


                          </Select>
                        </FormControl>
                      )}
                    </FastField>
                  </div>
                  {!headerSubtitle && <div className="col-12">
                    <FastField name="object">
                      {({ field }) => (
                        <FormControl variant="outlined" size="small" fullWidth
                                     className="long-select">
                          <InputLabel>Выберите объект</InputLabel>
                          <Select
                            label="Выберите объект"
                            {...field}
                          >
                            {objectsAvailability && objectsAvailability.map(obj => {
                              return <MenuItem key={obj.id} value={obj.id}>
                                {obj.name}
                              </MenuItem>
                            })}

                          </Select>
                        </FormControl>
                      )}
                    </FastField>
                  </div>}
                  <div className="col-12 text-center">
                    <Button className={`btn ${buttons.btnGreen}`} type="submit">Выбрать</Button>
                  </div>
                </div>

              </div>
            </Collapse>
            {!mobileAgent && <AutoSaveWithDebounce debounceMs={10}/>}
          </Form>)}
      </Formik>


      <Modal toggleShow={toggleShowInstruction} show={showInstruction}
             title={"Инструкция:"}
             textBtnOk={"Понятно"}>
        <Typography variant="body1" gutterBottom>
          <b>1. Выбор номера для редактирования.</b> Нажмите на кнопку "Выберите номер" напротив фразы
          "Количество свободных номеров" в верхней части экрана. В выпадающем списке выберите номер для
          редактирования;
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>2. Выбор периода для редактирования.</b> Необходимо нажать на две даты в календаре, первая будет
          началом, вторая - окончанием периода. После, нажмите кнопку редактировать в нижней части экрана;
        </Typography>

        <Typography variant="body1" gutterBottom>
          <b>3. Редактирование доступности номеров.</b> После того, как Вы выбрали период и нажали кнопку
          "Редактировать", в правой части экрана появится блок с редактированием занятости на выбранный
          период. В этом блоке Вы можете изменить занятость на весь выбранный период, просто введите
          количество доступных номеров в самое верхнее поле рядом с фразой "Доступно". Так же Вы можете
          изменить доступность отдельно на любой день из выбранного периода. Для этого надо нажать на кнопку
          "Показать все" и Вам будет открыт список занятости на каждый день выбранного периода;
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>4. Сохранение изменений.</b> После того как Вы задали нужные значения в блоке редактирования
          доступности (прим. п.4), нажмите кнопку "Сохранить" в нижней части данного блока.
        </Typography>

      </Modal>

    </div>

  )
}


const Picker = React.memo(({ children, date, updPicker, value, closeCollapse, updatePeriodBusy }) => {
  const increment = () => {
    if (date === "allDates") {
      closeCollapse()
      updatePeriodBusy(+value + 1)
    } else {
      updPicker(date, +value + 1)
    }
  }

  const decrement = () => {
    if (value !== 0) {
      if (date === "allDates") {
        closeCollapse()
        updatePeriodBusy(+value - 1)
      } else {
        updPicker(date, +value - 1)
      }
    }
  }

  return (
    <div className="picker">

      <Button className="minus"
              disabled={value === 0}
              onClick={decrement}>
        <FontAwesomeIcon icon={"minus"}/>
      </Button>

      {children}

      <Button className="plus"
              onClick={increment}>
        <FontAwesomeIcon icon={"plus"}/>
      </Button>

    </div>
  )
})


const RenderBusyLineHeader = React.memo(({ date, updatePeriodBusy, closeCollapse, updPicker }) => {

  const [changePeriod, setChangePeriod] = useState(false)

  //контекст формы, беру валуе и методы обновления филда и получения филда
  const { values, setFieldValue } = useFormikContext();

  let prevAllDatesAvailibility = usePrevious(values && values[date])


  //еффект изменения занятости на период
  useEffect(() => {
    if (values && prevAllDatesAvailibility !== values[date] && changePeriod) {
      updatePeriodBusy(values[date])
    }
  }, [values && values[date]])


  useEffect(() => {
    if (values) {
      let uniqValues = new Set(Object.values(values))
      if (values && prevAllDatesAvailibility === values[date] && uniqValues.size > 1 && !changePeriod) {
        //если цена в филде периода дат не совпадает с предидущей ценой в этом филде и не равна пустой строке то заходим в условие
        setFieldValue(`${date}`, '')
      }
    }

  }, [values])


  return (
    <div className="body__busy-line">
      <div className="row gx-2 align-items-center">
        <div className="col-5">
          <div className="text">
            Доступно
          </div>
        </div>
        <div className="col-7">
          <Picker date={date} updPicker={updPicker} value={values && values[date]}
                  closeCollapse={closeCollapse} updatePeriodBusy={updatePeriodBusy}>
            <FormControl className="">
              <FastField name={date}>
                {({ field }) => {
                  return (
                    <CustomInputNumber {...field}
                                       onBlur={() => setChangePeriod(false)}
                                       onFocus={() => {
                                         closeCollapse()
                                         setChangePeriod(true)
                                       }}
                                       placeholder="---"
                                       type="number"/>

                  )
                }}
              </FastField>
            </FormControl>
          </Picker>
        </div>
      </div>
      <div className="col-12">
        <span className="text-muted small">Количество свободных номеров на выбранные даты</span>
      </div>

    </div>
  )
})

const RenderBusyLine = React.memo(({ date, updPicker, value }) => {


  return (
    <div className="body__busy-line">
      <div className="row gx-2 align-items-center">
        <div className="col-5">
          <div className="text">
            {date.split("-").reverse().join(".")}
          </div>
        </div>
        <div className="col-7">
          <Picker date={date} updPicker={updPicker} value={value}>
            <FormControl className="">
              <FastField name={date}>
                {({ field }) => {
                  return (
                    <CustomInputNumber {...field}
                                       placeholder="---"
                                       type="number"/>

                  )
                }}
              </FastField>

            </FormControl>
          </Picker>
        </div>
      </div>
    </div>
  )
})

//основной компонент календаря занятости
const CalendarBusy = (props) => {
  const {
    objects,
    objectsAvailability,
    objectId,
    getAvailabilityTable,
    getRoomsListForAvailibility,
    roomsList,
    roomId,
    updateAvailability,
    availabilitiesId,
    userRole,
    removeAvailability,
    getAvailabilityObjectsList,
    searchObjects,
    changeRoom,
    changeObject,
    headerSubtitle,
    channelManagerId,
    channelManagerLink,
    roomName
  } = props
  const [dates, setDates] = useState()
  const [months, setMonths] = useState()
  const [startRangeDate, setStartRangeDate] = useState(null)
  const [endRangeDate, setEndRangeDate] = useState(null)
  const [dateRange, setDateRange] = useState("")
  const [datesLines, setDatesLines] = useState()
  const [lastDate, setLastDate] = useState()
  const [initValue, setInitValue] = useState()
  const [activityType, setActivityType] = useState(null)

  const [show, setModalShow] = useState(false);
  //открытие/закрытие модалок
  const toggleShow = (showStatus) => {
    setModalShow(showStatus)
  };

  const [expandedBusyLines, setExpandedBusyLines] = useState(false);
  const handleExpandBusyLinesClick = () => {
    setExpandedBusyLines(!expandedBusyLines);
  };

  useEffect(() => {
    if (userRole === "MODERATOR")
      return () => {
        removeAvailability()
      };
  }, [])

  useEffect(() => {
    if (!objectsAvailability && objects) {
      getAvailabilityObjectsList(objects)
    }
  }, [objects])


  useEffect(() => {
    if (!objectsAvailability && !objects && objectId && userRole === "MODERATOR") {
      searchObjects(objectId)
    }
  }, [objects])


  const prevObjectId = usePrevious(objectId)
  useEffect(() => {

    if (objectId && prevObjectId !== objectId) {
      getRoomsListForAvailibility({ object: objectId })
    }
  }, [objectId])


  useEffect(() => {
    if (roomId) {
      getAvailabilityTable({ room: roomId })
    }
  }, [roomId])

  useEffect(() => {
    if (dates !== props.dates) {
      setDates(props.dates)
    }
  }, [props.dates])


  //после получения цен готовим их к рендеру
  useEffect(() => {
    if (dates) {
      let months = []
      let yearMonth = []

      //получаем год и месяц каждой цены
      Object.keys(dates).map((key) => {
        yearMonth.push(key.slice(0, 7))
      })

      //выбираем только уникалыный год/месяц
      let uniqueYearMonth = [...new Set(yearMonth)]

      //получаем массивы дат всех месяцев
      let monthDates = []
      for (let i = 0; i < uniqueYearMonth.length; i++) {
        monthDates.push(Object.keys(dates).filter((date) => date.slice(0, 7) === uniqueYearMonth[i]))
      }

      //делаем объекты месяцев с полными данным по ценам
      for (let i = 0; i < monthDates.length; i++) {
        let month = {}
        monthDates[i].map((date) => month = { ...month, [date]: dates[date] })
        months.push(month)
      }


      setLastDate(Object.keys(dates)[Object.keys(dates).length - 1])
      //сетаем в стейт массив с объектами по месяцам
      setMonths(months)
    }
  }, [dates])


  //выбор начальной и конечной дат диапазона
  const selectDate = (date) => {
    //если нет начальной даты периода то устанавливаем ее, в противном случае установливаем  установливаем конечную дату периода
    if (!startRangeDate) {
      setStartRangeDate(date)
      setEndRangeDate(date)
    } else {
      //если начальная дата диапазона меньше новой пришедшей из параметра, то добавляем новую дату в конец диапазона
      //в противном случае дату начала диапозона добавляем в конец, а дату из параметра устанавливаем датой начала диапазона
      if (new Date(startRangeDate).getTime() < new Date(date).getTime()) {
        setEndRangeDate(date)
      } else {
        setEndRangeDate(startRangeDate)
        setStartRangeDate(date)
      }
    }

    //(if) Если выбрана 2 или меньше дат то в объект даты добавляем свойство selected.
    //(else) Или если в объекте дат, больше 2х дат с атрибутом selected, тогда удаляем у всех свойство selected,
    // устанавливаем выбранную дату начальной и устанавливаем свойство selected, удаляем конечную дату периода.
    if (Object.values(dates).filter(date => date.selected === true).length <= 1) {
      setDates({ ...dates, [date]: { ...dates[date], selected: true } })
    } else {
      let newDates = { ...dates }
      Object.keys(dates).map((key) => newDates = { ...newDates, [key]: { ...dates[key], selected: false } })
      setStartRangeDate(date)
      setEndRangeDate(date)
      setDates({ ...newDates, [date]: { ...dates[date], selected: true } })
    }
  }

  //эфект изменения начальной и конечной дат периода
  useEffect(() => {
    if (startRangeDate && endRangeDate) {

      //получаем индекс начальной даты периода в общем объекте дат
      let startRangeIndex = Object.keys(dates).indexOf(startRangeDate)
      //получаем индекс конечной даты периода в общем объекте дат
      let finishRangeIndex = Object.keys(dates).indexOf(endRangeDate)

      //даты входящие в диапазон между начальной и конечной датой периода
      let datesRange = []

      //берем количесво дат равное разности старшей по индексу и младшей по индексу дат, и перебираем ключи дат начиная от младшего по индексу
      if (finishRangeIndex > startRangeIndex) {
        for (let i = 0; i <= finishRangeIndex - startRangeIndex; i++) {
          datesRange.push(Object.keys(dates)[startRangeIndex + i])
        }
      } else {
        for (let i = 0; i <= startRangeIndex - finishRangeIndex; i++) {
          datesRange.push(Object.keys(dates)[finishRangeIndex + i])
        }
      }

      //устанавливаем в стейт диапазон выбранных дат
      setDateRange(datesRange)

      //т.к setState запрещено делать в цикле, присваем первичный объект дат переменной, в цикле перебираем даты периода и устанавливаем им свойтво selected: true
      let newDates = { ...dates }
      datesRange.map((date) => newDates = { ...newDates, [date]: { ...newDates[date], selected: true } })

      //перезаписываем начальный объект с датами
      setDates(newDates)
    }

  }, [startRangeDate, endRangeDate])


  useEffect(() => {
    if (dateRange) {
      let datesLines = {}

      dateRange.map((date) => {
        datesLines = { ...datesLines, [date]: dates[date].count }
      })

      setDatesLines(datesLines)


      let uniqAvailability = new Set(Object.values(datesLines))
      if (uniqAvailability.size === 1) {
        setInitValue({ allDates: [...uniqAvailability][0] })
      } else {
        setInitValue({ allDates: '' })
      }
    }


  }, [dateRange])


  //закрытие модалки изменения цен
  const closeModalBusy = () => {
    setStartRangeDate(null)
    setEndRangeDate(null)
    setDatesLines(null)

    let newDates = { ...dates }
    Object.keys(dates).map((date) => {
      delete newDates[date].selected
    })
    setDates(newDates)
    setExpandedBusyLines(false)
    toggleShow(false)
  }


  //сабмит занятости
  const onBusySubmit = async (values) => {

    closeModalBusy()

    let submitingValue = {}
    if (Object.keys(values).length === 1) {

      dateRange.map(date => {
        submitingValue = {
          ...submitingValue,
          [date]: {}
        }
      })
      dateRange.map(date => {

        submitingValue = {
          ...submitingValue,
          [date]: {
            ...submitingValue[date],
            count: datesLines[date] || datesLines[date] === 0 ? datesLines[date] : Object.values(values)[0],
            id: availabilitiesId && availabilitiesId[date] ? availabilitiesId[date] : null,
            active: activityType
          }
        }
      })


    } else {
      Object.keys(values).map(item => {
        if (item !== "allDates") {
          submitingValue = {
            ...submitingValue,
            [item]: {
              ...submitingValue[item],
              count: values[item],
              id: availabilitiesId && availabilitiesId[item] ? availabilitiesId[item] : null,
              active: activityType
            }
          }
        }
      })
    }
    if (activityType) setActivityType(null)

    updateAvailability({
      object: objectId,
      room: roomId,
      availability: JSON.stringify(submitingValue)
    })


  }

  //реф формы занятости
  const formRef = useRef()

  //переназначенный submit формы занятости
  const onBusySubmitHandler = (activity) => {
    if (formRef.current) {
      if (activity) setActivityType(activity)
      formRef.current.handleSubmit()
    }
  }

  //autosubmit dates to ModalChangeCalendar
  const updateDates = (values) => {
    if (values.dates) {
      for (let i = 0; i < values.dates.length; i++) {
        if (values.dates[0] && values.dates[1]) {
          setStartRangeDate(new Date(values.dates[0]).toLocaleDateString('ru-RU').split(".").reverse().join("-"))
          setEndRangeDate(new Date(values.dates[1]).toLocaleDateString('ru-RU').split(".").reverse().join("-"))
        }
      }
    }
  }

  const validateDatepicker = (values) => {
    let errors = {}

    let yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).getTime()
    let maxDate = new Date(lastDate).getTime()
    let startDate = new Date(values.dates[0]).getTime()
    let finishDate = new Date(values.dates[1]).getTime()

    if (values.dates[0]?.toString() === "Invalid Date" || values.dates[1]?.toString() === "Invalid Date") {
      errors = { dates: "Некорректные даты" }
    }
    if (startDate < yesterday || finishDate < yesterday || startDate > maxDate || finishDate > maxDate) {
      errors = { dates: "Выбраны даты не входящие в календарь" }
    }
    if (finishDate < startDate) {
      errors = { dates: `Дата "от" не может быть меньше даты "до"` }
    }

    return errors
  }

  const updatePeriodBusy = (values) => {

    let newDatesLines = { ...datesLines }
    Object.keys(newDatesLines).map(date => {
      newDatesLines = { ...newDatesLines, [date]: values }
    })

    setInitValue({ ...initValue, allDates: values })
    setDatesLines(newDatesLines)

  }

  const updateInitValue = (formValue) => {
    handleExpandBusyLinesClick()
    if (!expandedBusyLines) {
      let newInitValue = { ...formValue }
      Object.keys(datesLines).map(date => {
        newInitValue = { ...newInitValue, [date]: datesLines[date] }
      })

      setInitValue(newInitValue)
    }
  }

  const updPicker = (date, newCount) => {
    let formValues = formRef.current.values
    setInitValue({ ...formValues, [date]: newCount })
  }


  const buttons = themeButtons()
  if (objectsAvailability && objectsAvailability.length === 0) {
    return <div className="main">
      <div className="container-fluid">
        у вас пока нет объектов
      </div>
    </div>
  }
  if (roomsList && roomsList.length === 0) {


    return <div className={`main edit-busyCalendar ${headerSubtitle ? "edit-calendar edit-object" : ''}`}>
      <RenderSettingsMenu roomsList={roomsList}
                          objectsAvailability={objectsAvailability}
                          objectId={objectId}
                          roomId={roomId}
                          changeRoom={changeRoom}
                          changeObject={changeObject}
                          userRole={userRole}
                          headerSubtitle={headerSubtitle}/>
      <div className="container-fluid">
        <h6 className="w-100 text-center mt-5">
          В выбранном объекте пока нет номеров <br/>
          <Link component={NavLink} to={`/lk/${objectId}/rooms/new`}>Перейти к добавлению</Link>
        </h6>
      </div>
    </div>


  }

  if (!roomsList || !dates) {
    return <Preloader loading={true} text="Загружаем календарь..."/>
  }

  return (
    <div className={`main edit-busyCalendar ${headerSubtitle ? "edit-calendar edit-object" : ''}`}>
      <RenderSettingsMenu roomsList={roomsList}
                          objectsAvailability={objectsAvailability}
                          objectId={objectId}
                          roomId={roomId}
                          changeRoom={changeRoom}
                          changeObject={changeObject}
                          userRole={userRole}
                          headerSubtitle={headerSubtitle}/>

      <div className="container-fluid">
        {!!channelManagerId && <Box className="alert alert-danger">
          <Typography variant={"subtitle1"}> Вы используете менеджер каналов для управления доступностью и
            ценами.</Typography>
          {channelManagerLink
            ? (<Typography variant={"subtitle1"}> Чтобы внести изменения,
              перейдите по ссылке: <Link href={channelManagerLink}>Изменить цены и
                доступность</Link></Typography>)
            : (<Typography variant={"subtitle1"}> Чтобы внести изменения,
              перейдите в Ваш менеджер каналов</Typography>)
          }


        </Box>}

        <div className="alert alert-warning">
          Выберите даты для редактирования
        </div>
        <div className="alert alert-warning">
          Числа в ячейках отображают количество свободных номеров, выбранной категории, в эту дату
        </div>
        <h5 className="d-lg-none">{roomsList && roomsList.filter(room => room === roomId).name}</h5>


        <div className="room-calendar__table busyCalendar">
          <div className="room-calendar__table-period days">
            <div className="row g-4 mb-3 row-cols-1 row-cols-md-2 row-cols-xxl-3">
              {months && months.map((month, index) => {
                return <Month key={index} month={month} selectDate={selectDate} type="busy"/>
              })}
            </div>
          </div>
        </div>


        <ModalChangeCalendar show={show}
                             toggleShow={toggleShow}
                             exitModal={closeModalBusy}
                             btnSaveAction={onBusySubmitHandler}
                             calendar={!headerSubtitle && "busy"}>
          <div className="body__date">
            <div className="row gx-2">

              <Formik
                initialValues={{ dates: [startRangeDate, endRangeDate] }}
                onSubmit={updateDates}
                validate={validateDatepicker}
                enableReinitialize>
                {({ errors }) => (
                  <Form>
                    <DateRangePickerComponent
                      name="dates"
                      startText="Дата от"
                      endText="Дата до"
                      disablePast={true}
                      maxDate={new Date(lastDate)}
                      error={Boolean(errors.dates)}
                      helperText={errors.dates}
                    />
                    <AutoSaveWithDebounce debounceMs={100}/>
                  </Form>
                )}

              </Formik>

            </div>
          </div>

          <Formik
            innerRef={formRef}
            initialValues={initValue}
            enableReinitialize
            onSubmit={onBusySubmit}>
            {({ values, handleSubmit }) => (
              <Form>

                <RenderBusyLineHeader date={"allDates"}
                                      updatePeriodBusy={updatePeriodBusy}
                                      updPicker={updPicker}
                                      closeCollapse={() => setExpandedBusyLines(false)}/>


                <Collapse in={expandedBusyLines} timeout="auto">
                  {initValue && Object.keys(initValue).map((date) => {
                    if (date !== "allDates") {
                      return (<RenderBusyLine key={date} updPicker={updPicker} date={date}
                                              value={values[date]}/>)
                    }
                  })}
                </Collapse>


                <div className="d-flex w-100 justify-content-center">
                  {expandedBusyLines
                    ? <Button
                      className={`btn ${buttons.btnLight}`}
                      onClick={() => updateInitValue(values)}>
                      Скрыть
                      <FontAwesomeIcon icon={"chevron-up"} className="ms-1"/>

                    </Button>
                    : <Button
                      className={`btn ${buttons.btnLight}`}
                      onClick={() => updateInitValue(values)}>
                      Показать все
                      <FontAwesomeIcon icon={"chevron-down"} className="ms-1"/>
                    </Button>
                  }
                </div>


              </Form>
            )}

          </Formik>

        </ModalChangeCalendar>
      </div>

      <StickyBottomButton action={() => toggleShow(true)}
                          page="price"
                          disbaledBtn={channelManagerId}
                          btnText={`${startRangeDate ? startRangeDate.split("-").reverse().join(".") : ""}
                                            ${endRangeDate ? ' / ' : ""}
                                            ${endRangeDate ? endRangeDate.split("-").reverse().join(".") : ""} `}
                          titleText={roomName}/>
    </div>
  );
};


export default CalendarBusy;
